module.exports = __webpack_public_path__ + "img/2.7117c26f.png";